module.exports = __webpack_public_path__ + "img/memberedit.6a879a7e.svg";